import { useApiClient } from '@klareospace/pharos-lib-front-utils';
import type { CreateVehicleTemplate, VehicleTemplate } from '@klareospace/pharos-lib-types';
import type { UseMutationResult } from '@tanstack/react-query';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';

import { createMutationCallbacks } from '@klareospace/pharos-lib-web-utils';

import { createVehicleTemplateApi, vehicleTemplateKeys } from '../api';

// ─── Hook ─────────────────────────────────────────────────────────────────────

export function useCreateVehicleTemplate(): UseMutationResult<VehicleTemplate, Error, CreateVehicleTemplate> {
  const client = useApiClient('admin-auth');
  const api = createVehicleTemplateApi(client);
  const queryClient = useQueryClient();
  const { t } = useTranslation('settings');

  return useMutation<VehicleTemplate, Error, CreateVehicleTemplate>({
    mutationFn: (data: CreateVehicleTemplate) => api.createVehicleTemplate(data),
    ...createMutationCallbacks({
      errorKey: 'vehicleTemplates.toast.createError',
      invalidateKeys: [vehicleTemplateKeys.all],
      queryClient,
      successKey: 'vehicleTemplates.toast.createSuccess',
      t,
    }),
  });
}
